import { render, staticRenderFns } from "./kuan.vue?vue&type=template&id=98721bc0&scoped=true"
import script from "./kuan.vue?vue&type=script&lang=js"
export * from "./kuan.vue?vue&type=script&lang=js"
import style0 from "./kuan.vue?vue&type=style&index=0&id=98721bc0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98721bc0",
  null
  
)

export default component.exports